import { MultiValue, Select } from "chakra-react-select";
import {
  Box,
  Button,
  Heading,
  HStack,
  IconButton,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";
import { FiEdit2 } from "react-icons/fi";
import { KYDGenreLabel, KYDGenresList } from "../../Genres";

const GenresSection = ({
  data,
  isLoading = false,
  onSave,
  readOnly = false,
}: {
  readOnly?: boolean;
  data: {
    genres: {
      name: string;
      id: string;
    }[];
  };
  onSave: (genres: { name: string; id: string }[]) => Promise<void>;
  isLoading: boolean;
}) => {
  const [genres, setGenres] = useState<
    MultiValue<{
      label: string;
      id?: string;
      value: string;
    }>
  >([]);
  const [isEditing, setIsEditing] = useState(false);

  const onDiscard = useCallback(() => {
    setGenres(
      data.genres?.map((g) => ({
        label: KYDGenreLabel[g.name] || g.name,
        value: g.name,
        id: g.id,
      }))
    );
  }, [data]);

  useEffect(() => {
    if (data.genres && !isEditing) {
      onDiscard();
    }
  }, [data]);

  const _onSave = async () => {
    console.log({ inside: genres });
    await onSave(genres.map((g) => ({ name: g.value, id: g.id })));
    setIsEditing(false);
  };

  return (
    <VStack w="full" pt={8}>
      <HStack w="full">
        <Heading size="sm">Genres</Heading>
        {!readOnly ? (
          <IconButton
            variant={"ghost"}
            isDisabled={isEditing}
            aria-label="Add ticket type"
            icon={<FiEdit2 fontSize="1.25rem" />}
            onClick={() => {
              setIsEditing(!isEditing);
            }}
          />
        ) : null}
      </HStack>
      {isEditing ? (
        <Select
          isMulti
          isDisabled={isLoading || readOnly}
          closeMenuOnSelect={false}
          value={genres}
          onChange={(values) => setGenres(values)}
          chakraStyles={{
            container: () => ({
              position: "relative",
              width: "100%",
            }),
          }}
          options={KYDGenresList.map((g) => ({
            label: g.label,
            value: g.name,
          }))}
        />
      ) : (
        <HStack width={"full"} flexWrap={"wrap"}>
          {genres.map((g) => (
            <Box
              bg="gray.200"
              color="black"
              fontSize={"small"}
              fontWeight={"medium"}
              borderRadius={"md"}
              p={1}
              px={2}
            >
              <Text key={g.value}>{g.label}</Text>
            </Box>
          ))}
          {genres.length === 0 && !isEditing ? (
            <VStack
              w="full"
              color="gray.500"
              alignItems={"flex-start"}
              spacing={3}
            >
              <Text w="full">No genres created</Text>
            </VStack>
          ) : null}
        </HStack>
      )}
      <VStack w="full" alignItems={"flex-end"} py={4}>
        {isEditing && !readOnly ? (
          <HStack>
            <Button
              onClick={() => {
                setIsEditing(false);
                onDiscard();
              }}
              isDisabled={isLoading}
              isLoading={isLoading}
            >
              Discard
            </Button>
            <Button
              onClick={() => {
                _onSave();
              }}
              isLoading={isLoading}
              isDisabled={isLoading}
              colorScheme={"green"}
            >
              Save
            </Button>
          </HStack>
        ) : null}
      </VStack>
    </VStack>
  );
};

export default GenresSection;
